var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pencil-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25129 4.09055L2.45479 10.887L1.52779 14.3445L0.918036 16.6223C0.901099 16.6859 0.901184 16.7529 0.918281 16.8165C0.935378 16.8801 0.968887 16.9381 1.01545 16.9846C1.06201 17.0312 1.12 17.0647 1.18359 17.0818C1.24718 17.0989 1.31415 17.099 1.37779 17.082L3.65404 16.4715L7.11229 15.5445H7.11304L13.9095 8.74804L9.25204 4.09055H9.25129ZM16.7198 4.87805L13.1228 1.2803C13.0532 1.21059 12.9705 1.15528 12.8796 1.11755C12.7886 1.07982 12.691 1.06039 12.5925 1.06039C12.494 1.06039 12.3965 1.07982 12.3055 1.11755C12.2145 1.15528 12.1319 1.21059 12.0623 1.2803L10.206 3.1358L14.8643 7.79405L16.7198 5.9378C16.7895 5.8682 16.8448 5.78555 16.8825 5.69457C16.9203 5.60358 16.9397 5.50605 16.9397 5.40755C16.9397 5.30905 16.9203 5.21151 16.8825 5.12053C16.8448 5.02954 16.7895 4.94689 16.7198 4.8773",
    fill: "#989BA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuIndividual);
export default __webpack_public_path__ + "static/media/icon_menu_individual.6baebed7011ce34a300cb049e68e08c4.svg";
export { ForwardRef as ReactComponent };